var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import i18next from "i18next";
import React from "react";
import styled from "styled-components";
import { MAIN_WRAP } from "../../classConstants";
import { Card } from "../../components/Form/Card/Card";
import { Portal } from "../../components/Portal/Portal";
import { ThemedDiv } from '../../Theme';
import { getClassName } from "../getClassName";
var AdminSettings = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    h3 {\n        margin-top: 0;\n    }\n"], ["\n    h3 {\n        margin-top: 0;\n    }\n"])));
var Cart = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    table {\n        margin-bottom: 2em;\n    }\n"], ["\n    table {\n        margin-bottom: 2em;\n    }\n"])));
var BookingForm = styled(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: -15px;\n"], ["\n    margin-top: -15px;\n"])));
export var getAdminContext = function (_a) {
    var actionBarRef = _a.actionBarRef;
    return {
        config: {
            is_admin: true,
            shouldScrollToParentTop: true,
            addToCart: {
                showAddToCartButton: false
            },
            bookingFormPopup: {
                showBookNow: function (_a) {
                    var itemsCount = _a.itemsCount;
                    return !itemsCount;
                },
                showAddToCart: function (_a) {
                    var defaultValue = _a.defaultValue;
                    return defaultValue;
                },
                showContinue: function (_a) {
                    var defaultValue = _a.defaultValue, itemsCount = _a.itemsCount;
                    return defaultValue && !itemsCount;
                },
                // showContinue: true,
                showBackButton: false,
                clearOnSubmit: true,
            }
        },
        presentation: {
            // icon: SvgIcon,
            // adminsettings: {
            //      component: (props) => <Portal style={{ order: -100 }} container={ actionBarRef?.current } { ...props}><ThemedDiv className={getClassName(MAIN_WRAP, "admin-setting-buttons")} >{props.children}</ThemedDiv></Portal>,
            // }
            bookingsettings: {
                basic: function (props) { return (React.createElement(AdminSettings, __assign({}, props, { title: props.title, className: getClassName(props.className, "ws-admin-settings") }),
                    React.createElement("div", { className: "ws-admin-settings-wrap" }, props.children))); },
            },
            modal: function (props) { return props.children; },
            wizard: {
                buttons: actionBarRef ? (function (_a) {
                    var children = _a.children;
                    return React.createElement(Portal, { style: { order: 10 }, container: actionBarRef === null || actionBarRef === void 0 ? void 0 : actionBarRef.current },
                        React.createElement(ThemedDiv, { className: getClassName(MAIN_WRAP, "wizard-buttons") }, children));
                }) : null,
            },
            bookingFormPopup: function (_a) {
                var children = _a.children;
                return React.createElement(BookingForm, { title: i18next.t("admin_booking_form.title") }, children);
            },
            recommended: {
                wrap: function (_a) {
                    var children = _a.children;
                    return React.createElement(React.Fragment, null, children);
                },
                field: function (_a) {
                    var children = _a.children;
                    return React.createElement(React.Fragment, null, children);
                },
                title: function (_a) {
                    var children = _a.children;
                    return null;
                },
            },
            cart: {
                buttons: actionBarRef ? (function (_a) {
                    var children = _a.children;
                    return React.createElement(Portal, { style: { order: 100 }, container: actionBarRef === null || actionBarRef === void 0 ? void 0 : actionBarRef.current },
                        React.createElement(ThemedDiv, { className: getClassName(MAIN_WRAP, "card-buttons") }, children));
                }) : null,
                cartTable: function (_a) {
                    var title = _a.title, description = _a.description, children = _a.children, props = __rest(_a, ["title", "description", "children"]);
                    return React.createElement("div", __assign({}, props),
                        React.createElement("div", null, title),
                        " ",
                        description,
                        " ",
                        children);
                },
                cart: function (_a) {
                    var itemCount = _a.itemCount, title = _a.title, description = _a.description, props = __rest(_a, ["itemCount", "title", "description"]);
                    return itemCount > 0 && React.createElement(Cart, __assign({}, props));
                },
            }
        }
    };
};
var templateObject_1, templateObject_2, templateObject_3;
